import { render } from "./Form.vue?vue&type=template&id=48f13007&scoped=true&ts=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=48f13007&lang=less&scoped=true"

import exportComponent from "D:\\project\\ding-salewo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f13007"]])

export default __exports__